module.exports = __webpack_public_path__ + "static/media/email.8fedb8e5.svg";